// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__YpgPA","label":"Section_label__2ZEEY","contentWrap":"Section_contentWrap__3sAox","footer":"Section_footer__FHmBX","footerInner":"Section_footerInner__3cfWj"};